export { default as home } from "./home";
export { default as about } from "./about";
export { default as links } from "./links";
export { default as startDrawing } from "./startDrawing";
export { default as contact } from "./contact";
export { default as viewNotFound } from "./viewNotFound";
export { default as drawing } from "./drawing";
